export var ADDON_ID = 'storybook/a11y';
export var PANEL_ID = "".concat(ADDON_ID, "/panel");
export var PARAM_KEY = "a11y";
export var HIGHLIGHT_STYLE_ID = 'a11yHighlight';
var RESULT = "".concat(ADDON_ID, "/result");
var REQUEST = "".concat(ADDON_ID, "/request");
var RUNNING = "".concat(ADDON_ID, "/running");
var ERROR = "".concat(ADDON_ID, "/error");
var MANUAL = "".concat(ADDON_ID, "/manual");
var HIGHLIGHT = "".concat(ADDON_ID, "/highlight");
export var EVENTS = {
  RESULT: RESULT,
  REQUEST: REQUEST,
  RUNNING: RUNNING,
  ERROR: ERROR,
  MANUAL: MANUAL,
  HIGHLIGHT: HIGHLIGHT
};